import { getTranslations } from "@/lib/i18n";

/**
 * Vaste sitetekst die op .de Duits moet zijn, terwijl de andere markten hun
 * bestaande (Nederlandse) tekst houden. De sleutel staat alleen in de.json;
 * `nlTekst` is wat elke andere taal al toonde en blijft ongewijzigd.
 *
 * Gebruik dit voor hardgecodeerde componenttekst die nog geen nl/fr/en/pl-sleutel
 * heeft. Een gewone `t("sleutel", "NL")` zou de component-pariteitstest dwingen
 * om de sleutel ook in de andere vier talen te zetten.
 */
/**
 * Taal van een API-verzoek. /api/* passeert de middleware niet, dus de taal komt
 * uit de Host (favotrip.de / www.favotrip.de); een vervalste header levert
 * hoogstens een andere taal van de melding op, nooit ander gedrag.
 */
export function requestDeLocale(request) {
  const h = request?.headers;
  const raw = h?.get?.("x-forwarded-host") || h?.get?.("host") || "";
  const host = raw.split(",")[0].trim().toLowerCase().replace(/:\d+$/, "");
  if (host === "favotrip.de" || host === "www.favotrip.de") return "de";
  return "nl";
}

export function deTekst(locale, key, nlTekst, vars) {
  if (locale !== "de") return nlTekst;
  return getTranslations("de").t(key, nlTekst, vars);
}
